const stickifyNav = el => {

  let elTop = el.offsetTop;
  const closebandoBtn = document.querySelector(".bandeau-corona .close-btn");

  let stickyNavigation = () => {

    if (window.scrollY >= elTop) {


      el.classList.add('stuck');
      setTimeout(() => {
        el.classList.add('show');
      }, 100);

      if(closebandoBtn)
      {
        let bandoHeight = document.querySelector('.bandeau-corona').clientHeight    

        if(document.querySelector('.bandeau-corona').classList.contains('open'))
        {
          document.querySelector('header .header-container').style.marginTop = bandoHeight + "px"
        }
        
      }

    } else {
      el.classList.remove('stuck');
      el.classList.remove('show');
      document.querySelector('header .header-container').style.marginTop = 0
    }
  }

  window.addEventListener('scroll', stickyNavigation);
}

export default stickifyNav;
